<div class="clock-utc">
    <span class="clock-utc__time">{{ clockUtc() }} UTC</span>
    <info-tooltip id="clock-utc" [text]="'toolbar.clockUtcInfo'" [iconClass]="'fa-regular fa-circle-info'" />
</div>
